import { CircularProgress, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function SessionLoadingScreen({ info }: { info?: string }) {
  const { t } = useTranslation();
  return (
    <Stack
      sx={{
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <CircularProgress size={60} />
      {info && (
        <Typography variant='h6' color='text.secondary'>
          {t(info)}
        </Typography>
      )}
    </Stack>
  );
}
